<customer-header-template [customer]="data.customer"></customer-header-template>

<finder-search [initial]="search"
               searchType="customer"
               [id]="data.customer.id.toString()"
               [main]="data.customer.id.toString()">
</finder-search>
